<template>
  <div id="app">
    <Loading v-if="isLoading"/>
    <router-view>
      <Login />
    </router-view>
  </div>
</template>

<script>
import Loading from '@/components/elements/Loading';
import Login from '@/views/Login';

export default {
  name: 'app',
  data: function() {
    return {
      'isLoading': true
    };
  },
  components: {
    Loading,
    Login
  },
  methods: {
  },
  computed: {
  },
  mounted() {  
    this.isLoading = false;
  }
}
</script>

<style>
#app {
  font-family: "houschka-rounded", Sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  max-width: 500px;
  margin: auto;
  text-align: center;
}

.text--bold {
  font-weight: 500;
  font-family: "Urbane Rounded", sans-serif;
  font-size: 32px;
  line-height: 44px;
  margin: 32px auto 8px auto;
}
</style>
